export const getWhatsappIdentifier = (value) => {
  if (typeof value === "string") return value;
  return value?.identifier || value?.bsuid || value?.phoneNumber || value?.phone || "";
};

export const isWhatsappBsuid = (value) =>
  /^([A-Z]{2}\.)?\d+$/i.test(getWhatsappIdentifier(value)) &&
  getWhatsappIdentifier(value).includes(".");

export const getWhatsappIdentityKey = (value) => {
  const identifier = getWhatsappIdentifier(value);
  if (!identifier) return "";
  if (isWhatsappBsuid(identifier)) return identifier;
  const digits = identifier.replace(/\D/g, "");
  return digits ? digits.slice(-10) : identifier;
};

const getWhatsappIdentityKeys = (value) => {
  if (typeof value === "string") {
    const key = getWhatsappIdentityKey(value);
    return key ? [key] : [];
  }

  const candidates = [value?.identifier, value?.bsuid, value?.phoneNumber, value?.phone];
  return [...new Set(candidates.map(getWhatsappIdentityKey).filter(Boolean))];
};

export const isSameWhatsappIdentity = (left, right) => {
  const leftKeys = getWhatsappIdentityKeys(left);
  const rightKeys = new Set(getWhatsappIdentityKeys(right));
  return leftKeys.some((key) => rightKeys.has(key));
};

// El nombre guardado en la BD tiene prioridad sobre el perfil de WhatsApp;
// `user` puede contener el teléfono/BSUID cuando el contacto no tiene nombre.
const isIdentifierLike = (value, chat) =>
  !String(value || "").trim() ||
  getWhatsappIdentityKey(value) === getWhatsappIdentityKey(chat) ||
  isWhatsappBsuid(value) ||
  /^\+?[\d\s()-]+$/.test(value);

export const getWhatsappDisplayName = (chat) =>
  (!isIdentifierLike(chat?.user, chat) && chat?.user) ||
  chat?.profile?.name ||
  chat?.user ||
  chat?.profile?.username ||
  chat?.username ||
  getWhatsappIdentifier(chat) ||
  "Contacto de WhatsApp";

export const addWhatsappIdentityToMessage = (message, identity) => {
  const identifier = getWhatsappIdentifier(identity);
  return {
    ...message,
    identifier,
    identifierType: isWhatsappBsuid(identifier) ? "bsuid" : "phoneNumber",
    bsuid: isWhatsappBsuid(identifier) ? identifier : null,
    phoneNumber: isWhatsappBsuid(identifier) ? null : identifier,
  };
};
